import { List } from "immutable";
const DbDump = (state) => state.DbDump;

const selectIsLoading = (state) => DbDump(state).get("isLoading", false);
const selectMessage = (state) => DbDump(state).get("message", "");
const selectDbList = (state) => DbDump(state).get("dbList", List());

export { selectIsLoading, selectMessage, selectDbList };
